import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import "primeicons/primeicons.css";
import { CommonConfig } from "../../../CommonConfig.js";
import cogoToast from "cogo-toast";
import { Button } from "primereact/button";
import AddCompanyMaster from "./AddCompanyMaster.js";
import api from "utils/api.js";
import APIConstant from "utils/constant.js";
import SimpleBackdrop from "utils/general.js";
import { Dialog, DialogTitle } from "@material-ui/core";
import { DialogActions, DialogContent } from "@mui/material";

const CompanyMaster = ({ history }) => {
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState("");
    const [search, setSearch] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null); // for edit
    const [showForm, setShowForm] = useState(false);
    const [userPageAccess, setUserPageAccess] = useState([]);
    const [deleteDialog, setDeleteDialog] = useState(false);

    useEffect(() => {
        const data = localStorage.getItem("Infodata");
        const token = localStorage.getItem("Token");
        const access = JSON.parse(localStorage.getItem("PageAccess") || "[]");

        if (!token) {
            history.push("/login");
            return;
        }
        setUserId(data);
        setUserPageAccess(access);
        getCompanies(data);
    }, []);

    const getCompanies = async (UserId) => {
        setLoading(true);
        try {
            const res = await api.post(APIConstant.path.GetCompanyMaster, { UserId });
            if (res.success) {
                const filtered = res?.data?.filter((x) => x.UserId !== "Admin");
                setCompanyList(filtered);
            }
        } catch (err) {
            cogoToast.error("Failed to fetch companies");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            const res = await api.post(APIConstant.path.DeleteCompanyMaster, {
                CompanyMasterId: selectedCompany?._id,
                UserId: userId,
            });
            if (res?.success) {
                cogoToast.success(res?.message);
                handleClose('Delete')
                getCompanies(userId);
            } else {
                cogoToast.error(res?.message);
            }
        } catch (err) {
            cogoToast.error("Failed to delete company");
        } finally {
            setLoading(false);
        }
    };

    const filteredList = companyList.filter((c) =>
        c.CompanyName.toLowerCase().includes(search.toLowerCase())
    );

    const actionTemplate = (rowData) => (
        <div className="bill-action icon-only-btn" style={{ display: "flex" }}>
            {userPageAccess.includes("Edit Company Master") && (
                <div onClick={() => { setSelectedCompany(rowData); setShowForm(true); }}>
                    <i className="icon-editImage"></i>
                </div>
            )}
            {userPageAccess.includes("Delete Company Master") && (
                <div onClick={() => {
                    setSelectedCompany(rowData);
                    setDeleteDialog(true);
                }}>
                    <i className="icon-delete"></i>
                </div>
            )}
        </div>
    );
    const addressTemplate = (rowData) => (
        <div> {rowData?.address?.Address}</div>
    );

    const handleClose = (type) => {
        if (type === "Delete") {
            setDeleteDialog(false);
            setSelectedCompany(null);
        }
    };
    return (
        <div className="wayment-owner-dashboard e-weighment-dashoard">
            {loading && <SimpleBackdrop />}
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-center">
                    <i className="pi pi-clone"></i>
                    <h2>Company Master</h2>
                </div>
                <div className="p-d-flex p-ai-center wb-filter-btn">
                    <div className="searchbar-area">
                        <InputText
                            type="search"
                            onInput={(e) => setSearch(e.target.value)}
                            placeholder="Global Search"
                            size="30"
                            style={{ marginRight: 10 }}
                        />
                        {/* <Button icon="pi pi-plus" onClick={() => { setSelectedCompany(null); setShowForm(true); }}>
                            Add
                        </Button> */}
                        {/* {userPageAccess.includes("Add Company Master") && (
                            <div>
                                <div
                                    className="e-add-btn"
                                    onClick={(e) => { setSelectedCompany(null); setShowForm(true); }}
                                >
                                    <i className="icon-add"></i>
                                </div>
                            </div>
                        )} */}
                    </div>
                    {userPageAccess.includes("Add Company Master") && (
                        <div>
                            <div
                                className="e-add-btn"
                                onClick={(e) => { setSelectedCompany(null); setShowForm(true); }}
                            >
                                <i className="icon-add"></i>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <hr />
            <DataTable
                className="main-table table-td e-company-table"
                value={filteredList}
                paginator
                rows={CommonConfig.dataTableConfig.rowsPerPage}
                rowsPerPageOptions={CommonConfig.dataTableConfig.rowsPerPageOptions}
                emptyMessage="No records found"
                responsiveLayout="scroll"
            >
                <Column header="Sr.No" body={(data, props) => props.rowIndex + 1} />
                <Column field="CompanyName" header="Company Name" />
                <Column field="GSTNo" header="Gst No" />
                <Column field="PanNo" header="Pan No" />
                <Column body={addressTemplate} field="Address" header="Address" />
                <Column header="Action" body={actionTemplate} />
            </DataTable>

            {showForm && (
                <AddCompanyMaster
                    open={showForm}
                    onClose={() => setShowForm(false)}
                    company={selectedCompany}
                    userId={userId}
                    refresh={() => getCompanies(userId)}
                />
            )}

            <Dialog
                open={deleteDialog}
                onClose={() => handleClose("Delete")}
                aria-labelledby="cha-form-dialog-title"
            >
                <DialogTitle
                    id="cha-form-dialog-title"
                    className="custom-dialog-header"
                >
                    <div>Delete Company Master</div>
                    <div className="dialog-close" onClick={(e) => handleClose("Delete")}>
                        <i className="icon-modal-close"></i>
                    </div>
                </DialogTitle>
                <DialogContent className="CHA-dialog-content-area">
                    <h6>Are you sure want to delete?</h6>
                </DialogContent>
                <DialogActions className="p-p-0 dialog-footer1">
                    <Button
                        className="primary-btn1"
                        onClick={(e) => handleClose("Delete")}
                    >
                        Close
                    </Button>
                    <Button
                        className="primary-btn"
                        onClick={(e) => handleDelete()}
                        type="submit"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CompanyMaster;
